<template>
    <div>
        <div v-if="loading_page === true">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                <v-skeleton-loader type="article, actions"></v-skeleton-loader>
            </v-sheet>
        </div>
        <div v-else>
            <v-row>
                <v-col xs="12" sm="12" md="8" lg="10" xl="10" cols="12">
                    <div class="title_page ma-3 mb-0">
                        <h4 class="breadcrumb_title_page">รายละเอียดโปรโมชั่นแถมราคาถูกสุด</h4>
                        <v-breadcrumbs :items="sub_menu">
                            <template v-slot:divider>
                                <v-icon>mdi-chevron-right</v-icon>
                            </template>
                        </v-breadcrumbs>
                    </div>
                </v-col>
                <v-col xs="12" sm="12" md="4" lg="2" xl="2" cols="12">
                    <div class="title_page ma-3">
                        <v-btn type="button" class="btn_back_page" elevation="4" @click="$router.push({path: '/arin/pos/promotionlist', query: {tab: '1'}})"
                            large>ย้อนกลับ</v-btn>
                    </div>
                </v-col>
            </v-row>

            <section class="mt-10">
                <div class="ma-5">
                    <v-card elevation="4" class="pa-3 card_relative">
                        <div class="tag_header_profile d-flex">
                            <div class="grad-dark-brown-arin-bg pa-2 rounded-pill"
                                style="box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);z-index: 1">
                                <div class="logo_timeline mx-auto my-auto">
                                    <img src="@/assets/arin_assets/tag.png">
                                </div>
                            </div>
                            <v-card elevation="3" class="card_title ml-n5">
                                <div class="arin-text-color py-1 pl-8 pr-5">ข้อมูลโปรโมชั่น</div>
                            </v-card>
                        </div>
                        <v-row class="pa-4">
                            <v-col cols="12" lg="12" md="12" sm="12" xl="12">
                                <div class=" text_title">ชื่อโปรโมชั่น : <span
                                        class="text_detail">{{  promo.promotion_title }}</span></div>
                            </v-col>
                            <v-col cols="12" lg="6" md="6" sm="6" xl="6">
                                <div class=" text_title">วันที่เริ่มต้นโปรโมชั่น : <span
                                        class="text_detail">{{ promo.date_start }}</span></div>
                            </v-col>
                            <v-col cols="12" lg="6" md="6" sm="6" xl="6">
                                <div class=" text_title">วันที่สิ้นสุดโปรโมชั่น : <span
                                        class="text_detail">{{ promo.date_stop }}</span></div>
                            </v-col>
                            <v-col cols="12" lg="6" md="6" sm="6" xl="6">
                                <div class=" text_title">จำนวนสินค้าที่ต้องซื้อ : <span class="text_detail">{{ promo.promotion_buy }} ชิ้น</span></div>
                            </v-col>
                            <v-col cols="12" lg="6" md="6" sm="6" xl="6">
                                <div class=" text_title">จำนวนสินค้าที่แถม : <span class="text_detail">{{ promo.promotion_free }} ชิ้น</span>
                                </div>
                            </v-col>
                            <v-col cols="12" lg="6" md="6" sm="6">
                                <div class=" text_title">รายละเอียด : <span class="text_detail">{{ promo.promotion_detail }}</span></div>
                            </v-col>
                        </v-row>
                    </v-card>
                </div>
            </section>
            <section class="mt-15">
                <div class="ma-5">
                    <v-card elevation="4" class="pa-3 card_relative">
                        <div class="tag_header_profile d-flex">
                            <div class="grad-dark-brown-arin-bg pa-2 rounded-pill"
                                style="box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);z-index: 1">
                                <div class="logo_timeline mx-auto my-auto">
                                    <img src="@/assets/arin_assets/point.png">
                                </div>
                            </div>
                            <v-card elevation="3" class="card_title ml-n5">
                                <div class="arin-text-color py-1 pl-8 pr-5">สินค้าที่เข้าร่วมโปรโมชั่น</div>
                            </v-card>
                        </div>
                        <div class="mt-4">
                            <v-simple-table>
                                <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <th>ชื่อสินค้า</th>
                                            <th class="text-center">หน่วยนับ</th>
                                            <th class="text-center">ราคา</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(detail,index) in data_list" :key="index">
                                            <td class="hidden_line">{{ detail.product_name }}</td>
                                            <td class="text-center hidden_line">{{ detail.unit_name }}</td>
                                            <td class="text-center hidden_line">{{ detail.price_standard }}</td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </div>
                    </v-card>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import { HTTP_ARIN } from "@/axios_arin";
import { dateFormatDMYLean } from "@/js/dateformats";
export default {
    inject: {
        theme: {
            default: {
                isDark: false,
            },
        },
    },
    name: "Detail_customer_point",
    data() {
        return {
            loading_page: true,
            sub_menu: [
                {
                    text: 'ระบบ POS',
                    disabled: false,
                },
                {
                    text: 'คลังสินค้า',
                    disabled: false,
                },
                {
                    text: 'จัดโปรโมชั่นสินค้า',
                    disabled: false,
                },
                {
                    text: 'รายละเอียดโปรโมชั่นแถมราคาถูกสุด',
                    disabled: false,
                    href: '#',
                },
            ],
            promo: {
                promotion_title: '',
                promotion_code: null,
                date_start: '',
                date_stop: '',
                promotion_buy: '',
                promotion_free: '',
                promotion_detail: '',
                promotion_type: 0,
            },
            data_id: 1,
            data_list: [],
        }
    },
    methods:{
        async promotionDetail(){
            this.promo = {
                promotion_title: '',
                promotion_code: null,
                date_start: '',
                date_stop: '',
                promotion_buy: '',
                promotion_free: '',
                promotion_detail: '',
                promotion_type: 0,
            }
            this.data_id = 1
            this.data_list = []
            const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
            await HTTP_ARIN.get('/promotion/promodetail/'+this.$route.params.id, config).then((res) => {
                if (res.data.successful === true) {
                    this.promo = {
                        promotion_title: res.data.detail.promoDetail.promotion_title,
                        promotion_code: res.data.detail.promoDetail.promotion_code,
                        date_start: dateFormatDMYLean(res.data.detail.promoDetail.date_start),
                        date_stop: dateFormatDMYLean(res.data.detail.promoDetail.date_stop),
                        promotion_buy: res.data.detail.promoDetail.promotion_buy.toString(),
                        promotion_free: res.data.detail.promoDetail.promotion_free.toString(),
                        promotion_detail: res.data.detail.promoDetail.promotion_detail,
                        promotion_type: 0,
                    }
                    if (res.data.detail.product) {
                        const num = res.data.detail.product.length
                        for (let index = 0; index < num; index++) {
                            this.data_list.push({
                                id: this.data_id,
                                product_id: res.data.detail.product[index].product_id,
                                product_code: res.data.detail.product[index].product_code,
                                product_name: res.data.detail.product[index].name,
                                unit_id: res.data.detail.product[index].unit_id,
                                unit_name: res.data.detail.product[index].unit,
                                price_standard: res.data.detail.product[index].price_standard,
                            })
                            this.data_id += 1
                        }
                    }
                    this.loading_page = false
                }
            })
        },
    },
    mounted(){
        this.promotionDetail()
    },
}
</script>

<style scoped>
.card_relative {
    position: relative;
    border-radius: 15px;
}

.logo_timeline {
    width: 25px;
    height: 25px;
    padding: 0px;
}

.logo_timeline>img {
    max-width: 25px;
}

.tag_header_profile {
    position: absolute;
    top: -30px;
    left: -15px;
}

.arin-text-color {
    color: #84611F;
    font-weight: bold;
    font-size: 16px;
}

.card_title {
    margin-top: 1px;
    margin-bottom: 1px;
    border-radius: 10px;
    border: 1px solid #D6BFAF;
}

.text_title {
    color: #909090;
    font-weight: bold;
    font-size: 16px;
}

.text_detail {
    color: #616A6B;
    font-weight: bold;
    font-size: 16px;
}
</style>
